import {Quill} from 'react-quill';

import {PlaceholderBlot} from './placeholder-blot';
import type {Placeholder} from './placeholder-blot';

const Parchment = Quill.import('parchment');

type ModuleOptions = {
    placeholders: Placeholder[];
    onPlaceholderClick?: (quill: Quill, blot: PlaceholderBlot) => void;
};

export class PlaceholderModule {
    placeholders: Placeholder[];
    quill: Quill;
    onPlaceholderClick?: ModuleOptions['onPlaceholderClick'];

    constructor(quill: any, options: ModuleOptions) {
        this.quill = quill;
        this.placeholders = options.placeholders;
        this.onPlaceholderClick = options.onPlaceholderClick;
        // @ts-expect-error
        this.quill.root.addEventListener('click', this.onClick);
    }

    onClick = (e: React.ChangeEvent<any>) => {
        const target = e.target as HTMLElement | null;
        if (!target) {
            return;
        }
        // Find nearest placeholder blot
        const blotNode = target.closest('.ql-placeholder-blot');
        if (!blotNode) {
            return;
        }
        const blot = Parchment.find(blotNode);
        if (blot instanceof PlaceholderBlot) {
            if (this.onPlaceholderClick) {
                this.onPlaceholderClick(this.quill, blot);
            }
        }
    };
}
